import { Component, OnInit } from '@angular/core';

class model{
}

@Component({
	templateUrl: './documentsAdmission.component.html',
	styleUrls: ['./documentsAdmission.component.css']
})

export class DocumentsAdmissionComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/admission/documentsAdmission.component.ts